<template>
  <div>
    <v-carousel next-icon="mdi-chevron-right" prev-icon="mdi-chevron-left" @change="changeCarouselColaboration" height="650" hide-delimiters>
      <v-carousel-item
        v-for="(item,i) in colaborations"
        :key="i"
        :src="item.src_image"
      ></v-carousel-item>
    </v-carousel>

    <div class="d-block d-sm-block d-md-none">
      <MenuMobile :show_logo="false"/>
    </div>

    <div class="container" v-if="detail_colaboration">
      <div class="row mt-50 pa-sm-10">
        <div class="col">
          <div v-if="!detail_colaboration.show_logo" style="width: 300px" class="name-colaboration">
            <h3 class="color-blue font-general-r text-center">
              {{ detail_colaboration.name }}
            </h3>
          </div>

          <img
            v-else
            :src="detail_colaboration.src_logo"
            :alt="detail_colaboration.description"
            class="colaboration-logo"
          >
          <p
            class="color-blue font-general-r description-colaboration"
            v-html="detail_colaboration.description"
            :style="screen == 'mobile' ? 'text-align: left !important' : ''"
          >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomePageService from '@/services/home.service'
export default {
  data:() => ({
    colaborations: [],
    detail_colaboration: null,
    screen: 'desktop'
  }),
  methods: {
    changeCarouselColaboration(i) {
      this.detail_colaboration = this.colaborations[i]
    },
    async getColaborations() {
      const { data:res } = await HomePageService.getColaborations()
      this.colaborations = res
      this.detail_colaboration = res[0]
    }
  },
  created() {
    this.getColaborations()
  },
  mounted() {
    if (screen.width <= 425) {
      this.screen = 'mobile'
    }
  }
}
</script>

<style scoped>
  >>>.v-window__prev, >>>.v-window__next {
    background: none;
  }
  >>>.v-icon {
    font-size: 60px !important
  }
</style>
